function show_elements(event) {
    const loadmore = event.target;

    var number = loadmore.dataset.toLoad;
    var item = loadmore.dataset.item;
    var elements = document.getElementsByClassName(item);
    var i;
    var j = 0;

    for (i = 0; i < elements.length; i++) {
        if (elements[i].hidden === true) {
            if (j < number) {
                elements[i].hidden = false;
            }
            j++;
        }
    }
    if (j < number) {
        loadmore.style.display = "none";
    }
}

const loadmores = document.querySelectorAll(`.load-more`) || [];

loadmores.forEach((loadmore) => {
    var number = loadmore.dataset.show || loadmore.dataset.toLoad || 4;
    var item = loadmore.dataset.item;

    var x = document.getElementsByClassName(item);
    var i;

    for (i = number; i < x.length; i++) {
        x[i].hidden = true;
    }

    if (x.length <= number) {
        loadmore.style.display = "none";
    } else {
        loadmore.addEventListener("mousedown", show_elements);
    }

});

export default {};
